export default "__VITE_ASSET__DeZuxOQC__";